module.exports = __webpack_public_path__ + "img/exemple_format_excel_v2.dc4d7875.png";